/**
 * 归因 cookie 与 weee_session_token 的绑定校验。
 * session 轮换时清空归因数据；读取 API 在 binding 失效时返回 undefined。
 */

/** 是否已有归因数据（entry URL 或 referrer 快照任一非空） */
export const hasAttributedEntryData = (entryUrl?: string | null, referrerSnapshot?: string | null): boolean => {
  return Boolean(entryUrl?.trim() || referrerSnapshot?.trim());
};

/**
 * 是否应清空归因 cookie。
 * 有归因数据且 boundSession ≠ currentSession 时返回 true。
 */
export const shouldClearAttributedEntryForSession = (
  currentSession: string | undefined,
  boundSession: string | undefined,
  hasAttribution: boolean
): boolean => {
  if (!hasAttribution) {
    return false;
  }
  return (boundSession ?? '') !== (currentSession ?? '');
};
